const STORAGE_KEY = 'alakai_internal_planner_access';
const QUERY_KEYS = ['aa_internal_planner', 'internalPlanner'];
const LIVE_TEST_ISLANDS = new Set(['oahu']);

function isLocalRuntime() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost');
}

function canUseInternalPlannerAccess(islandKey) {
  if (isLocalRuntime()) return true;
  return LIVE_TEST_ISLANDS.has(islandKey);
}

function queryEnablesAccess() {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search || '');
  return QUERY_KEYS.some((key) => {
    const value = String(params.get(key) || '').toLowerCase();
    return value === '1' || value === 'true' || value === 'yes';
  });
}

export function hasInternalPlannerAccess(capability, islandKey = null) {
  if (capability !== 'tripPlanner' || !canUseInternalPlannerAccess(islandKey)) return false;

  if (queryEnablesAccess()) {
    window.localStorage?.setItem(STORAGE_KEY, '1');
    return true;
  }

  return window.localStorage?.getItem(STORAGE_KEY) === '1';
}

export const hasLocalInternalPlannerAccess = hasInternalPlannerAccess;
